import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconVideocameraOutline from '@adv-mt/mt-svg-icons/lib/VideocameraOutline'

import {BASE_CLASS} from '../config.js'

const VIDEO_AVALIBALE_ICON_ID_PREFIX = 'gallery-basic-video-available-icon-'

const VideoButton = ({handleClick, id, selectedSlide, showLargeVideoButton, videoPosition}) => {
  const {i18n} = useContext(Context)
  const baseClass = cx(`${BASE_CLASS}-videoButton`, {
    'is-small': !showLargeVideoButton
  })

  if (selectedSlide === videoPosition && showLargeVideoButton) return false
  return (
    <div
      className={baseClass}
      onClick={e => {
        e.preventDefault()
        handleClick({selectedSlide: videoPosition})
      }}
    >
      <IconVideocameraOutline id={`${VIDEO_AVALIBALE_ICON_ID_PREFIX}-${id}`} title={i18n.t('COMMON.VIDEO_AVAILABLE')} />
      {showLargeVideoButton ? i18n.t('COMMON.VIDEO') : null}
    </div>
  )
}

VideoButton.displayName = 'VideoButton'
VideoButton.propTypes = {
  handleClick: PropTypes.func,
  id: PropTypes.string,
  showLargeVideoButton: PropTypes.bool,
  selectedSlide: PropTypes.number,
  videoPosition: PropTypes.number
}

export default VideoButton
